import React from 'react';

import { useCms } from '~/components/hooks/useCms';

interface StoredFileLinkProps {
  storedFileId: number | null | undefined;
  filename: string;
  className?: string;
}

/**
 * Reusable component for displaying a clickable link to a stored file.
 * Opens the file in a new tab using the signed URL endpoint.
 */
const StoredFileLink: React.FC<StoredFileLinkProps> = ({ storedFileId, filename, className = '' }) => {
  const { user } = useCms();

  if (!storedFileId) {
    return <span className={className}>{filename}</span>;
  }

  return (
    <a
      href={`/api/v1/organizations/${user.organization_id}/signed_url/${storedFileId}`}
      target="_blank"
      rel="noopener noreferrer"
      className={`font-semibold text-blue-600 hover:underline ${className}`}
    >
      {filename}
    </a>
  );
};

export default StoredFileLink;
